import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { customerImport } from '../../features/dashboard/CustomerSlice';
import Loading from '../../Loading';
import Broadcast from './Broadcast';
import Header from './Header';
import Input from '../form/Input'; 
import Select from '../form/Select';
import Button from '../form/Button';
import { ToastContainer, toast } from 'react-toastify';
import { host } from '../../function/api'
import $ from 'jquery'
import Message from '../form/Message'

function CustomerImport() {
    const data = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const sanadno = useRef()
    const [excel, setExcel] = useState('')
    const [uploadType, setUploadType] = useState('')
    const [RKremaining, setRKremaining] = useState('0')
    let {
        loading,
        success,
        message,
        status,
        error,
        errorFile,
        errorUploadType,
        count_row,
        remaining,
        total
    } = useSelector((state) => state.customer)
    const token = localStorage.getItem('token')

    function handleApi(e) {
        const formData = new FormData()
        formData.append('file', excel)
        for (const value of formData.values()) {
            console.table(value);
        }
        dispatch(customerImport(formData))
      
    }

    useEffect(() => {
        if (loading === false && success === false) {
            if(message){
                toast.error(message, {
                    position: "top-center",
                    autoClose: 1200,
                })
            }
            message = ''
        }
    }, [data, loading])
    useEffect(() => {
        if(count_row != "" && count_row != total && success === true){
            handleApi();
        }else if(count_row != "" && count_row == total && success === true){
            toast.success('بارگذاری مشتریان با موفقیت به اتمام رسید.', {
                position: "top-center",
                autoClose: 1200,
            })
        }
        if(remaining != ""){
            $('.amaday-remaining-counter').text(remaining);
        }
    }, [count_row, total, remaining])

    return (
        <>
        {
            (loading === true ) ? (
                <div className="row wv-100 mh-100 p-0 m-0 position-fixed top-0 end-0 start-0 bottom-0 amaday-loading"
                    style={{zIndex: '300000'}}>    
                    <div className="d-flex justify-content-center align-items-center" 
                        style={{backgroundColor: 'rgb(0 0 0)' , opacity:0.900}}>
                        <div className='rahpardaznet-counter-text'>تعداد <span className='amaday-remaining-counter'>0</span> عدد باقی مانده است.</div>
                    </div>
                </div>
            ) : null
        }
            <Broadcast title={'بارگذاری مشتریان'} />
            <div className='row rahpardaznet-cart my-5 print-position'>
                <Header title='بارگذاری فایل مشتریان' />

                <div className="col-12">
                    <div className='row m-3 py-5 border border-3'>
                        <label htmlFor="formFile" className="form-label fw-bold text-end px-1 text-center">یک فایل با پسوند اکسل انتخاب کنید</label>
                        <input className="form-control form-control-lg invisible d-none" type='file' name='file' onChange={(e) => setExcel(e.target.files[0])} id="formFile" />
                        {
                            errorFile ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>
                                        {errorFile}
                                    </small>
                                </span>
                            ) : null
                        }
                    </div>
                </div>
                {<Message message={message} />}

            </div>

            <div className="row p-0">
                <div className='col-12 p-0'>

                    <button
                        tabIndex='14'
                        onClick={handleApi}
                        type="submit"
                        className="rahpardaznet-button">
                        {'   بارگذاری مشتریان  '}
                    </button>


                </div>
            </div>

        </>
    )
}

export default CustomerImport;